import { IntegrationType } from '../../interfaces/Integration';

export const state: any = {
  integration: {},
  processStats: {},
};
